import {FC, PropsWithChildren, useMemo} from "react";
import {useFormikContext} from "formik";
import {SelectorsFormsValues} from "@constructor/components/core/forms/selectors";
import {useAccounts} from "@hooks/selectors/user.selectors";
import {injectChild} from "@constructor/functions";

interface AccountsCountChildProps {
    form_accounts_count: number;
}

const AccountsCount: FC<PropsWithChildren> = ({children}) => {
    const {
        values: { selected_login_server },
    } = useFormikContext<SelectorsFormsValues>();

    const accounts = useAccounts(selected_login_server || '0');
    const data = useMemo<AccountsCountChildProps>(() => ({
        form_accounts_count: accounts.length
    }), [accounts]);

    return injectChild(data, children);
}

export default AccountsCount;